<template>
  <v-container
    fluid
    class="d-flex flex-column"
    :style="{
      backgroundImage: 'url(' + require('@/assets/beon.jpg') + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: '100vh',
      width: '100vw',
      margin: '0',
      padding: '0',
      overflow: 'hidden',
    }"
  >
    <v-layout>
      <v-flex>
        <v-row justify="center" align="center">
          <v-col cols="12" class="d-flex flex-column align-center text-center">
            <v-row justify="center" align="center" class="mt-14 my-8">
              <v-col cols="2" justify="center" align="center" class="pr-0">
                <v-img
                  contain
                  :src="require('@/assets/VP_sin_fondo.png')"
                  :class="{
                    'logo-class': $vuetify.breakpoint.smAndUp,
                    'logo-class-small': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-col>
              <v-col cols="2" justify="center" align="center" class="pl-0">
                <v-img
                  contain
                  src="img/beonit.png"
                  :class="{
                    'logo-class': $vuetify.breakpoint.smAndUp,
                    'logo-class-small': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-col>
            </v-row>

            <v-card class="mt-12 mx-4 pa-6" width="500">
              <v-card-title class="justify-center mb-6">
                <h5>Activate your account</h5>
              </v-card-title>

              <v-form
                v-if="
                  token !== null && token !== undefined && token !== 'null' && token !== 'undefined'
                "
                v-model="valid"
                @submit.prevent="activateAccount"
              >
                <v-card-text class="py-0">
                  <v-text-field
                    v-model="password"
                    class="py-0 mb-6 no-border-radius"
                    label="Password"
                    :rules="[passwordRules.required, passwordRules.minLength]"
                    dense
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="togglePasswordVisibility"
                  />
                  <v-text-field
                    v-model="confirmPassword"
                    class="mb-4 no-border-radius"
                    label="Repeat password"
                    :rules="[confirmPasswordRules.required, confirmPasswordRules.passwordMatch]"
                    dense
                    :type="showConfirmPassword ? 'text' : 'password'"
                    :append-icon="showConfirmPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="toggleConfirmPasswordVisibility"
                  />
                </v-card-text>

                <v-card-actions class="mx-2">
                  <v-btn
                    v-if="!activatingAccount"
                    class="mb-2"
                    color="primary"
                    block
                    type="submit"
                    :disabled="!isValidActivateAccount"
                  >
                    Activate
                  </v-btn>
                  <v-btn v-else color="primary" block type="submit" disabled>
                    <v-progress-circular indeterminate color="primary" />
                  </v-btn>
                </v-card-actions>
              </v-form>
              <v-alert v-else outlined :color="'error'" :icon="'mdi-alert'" class="mx-2 mt-2">
                Invalid user credentials, please make sure they are correct.
              </v-alert>

              <v-alert
                v-if="messageActivateAccount"
                outlined
                :color="successfullActivateAccount ? 'success' : 'error'"
                :icon="successfullActivateAccount ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
                class="mx-2 mt-2"
              >
                {{ messageActivateAccount }}
              </v-alert>

              <v-row class="center-content">
                <v-col cols="4">
                  <v-btn
                    v-if="messageActivateAccount && successfullActivateAccount"
                    class="mx-2 mb-2"
                    color="primary"
                    block
                    @click="goLogin()"
                  >
                    Go to login
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import AuthDataService from '@/services/AuthDataService';

export default {
  name: 'ActivateAccount',
  data() {
    return {
      token: null,
      valid: false,
      messageActivateAccount: '',
      successfullActivateAccount: false,
      activatingAccount: false,
      password: '',
      confirmPassword: '',
      passwordRules: {
        required: (v) => !!v || 'Required field',
        minLength: (v) => v.length > 7 || 'Min. length 8 characters',
      },
      confirmPasswordRules: {
        required: (v) => !!v || 'Required field',
        passwordMatch: (v) => v === this.password || 'Passwords do not match',
      },
      showPassword: false,
      showConfirmPassword: false,
    };
  },
  computed: {
    isValidActivateAccount() {
      return (
        this.password !== '' &&
        this.confirmPassword !== '' &&
        this.passwordRules.minLength(this.password) !== 'Min. length 8 characters' &&
        this.confirmPasswordRules.passwordMatch(this.confirmPassword) !== 'Passwords do not match'
      );
    },
  },
  mounted() {
    this.token = this.$route.query.token;
  },
  methods: {
    activateAccount() {
      this.messageActivateAccount = '';

      if (this.password !== this.confirmPassword) {
        this.successfullActivateAccount = false;
        this.messageActivateAccount = 'Passwords do not match.';
      } else {
        this.activatingAccount = true;

        AuthDataService.activateAccount(this.token, this.password).then(
          (response) => {
            if (response.status == 204) {
              this.successfullActivateAccount = true;
              this.messageActivateAccount =
                'Account successfully activated. You can now log in to your account.';
              this.password = '';
              this.confirmPassword = '';
            } else {
              this.successfullActivateAccount = false;
              this.messageActivateAccount =
                'An error occurred while activating account. Please, try again later.';
            }

            this.activatingAccount = false;
          },
          (error) => {
            this.successfullActivateAccount = false;
            console.error(
              (error.response && error.response.data) || error.message || error.toString()
            );

            if (error.response && error.response.status == 401) {
              if (error.response.data.code == 'INVALID_TOKEN') {
                this.messageActivateAccount =
                  'Invalid token. Please, check if the token is correct.';
              } else if (error.response.data.code == 'TOKEN_EXPIRED') {
                this.messageActivateAccount =
                  'Token expired. Please, generate another one to activate your account.';
              } else {
                this.messageActivateAccount =
                  'An error occurred while activating account. Please, try again later.';
              }
            } else if (error.response && error.response.status == 404) {
              this.messageActivateAccount =
                'User not found. Please, check if the token is correct or if the account is already activated.';
            } else {
              this.messageActivateAccount =
                'An error occurred while activating account. Please, try again later.';
            }

            this.activatingAccount = false;
          }
        );
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    goLogin() {
      this.$router.push('/');
    },
  },
};
</script>
